import React from "react";
import { Container } from "react-bootstrap";
import "./TerminalAssessmentRankingHeader.print.css";
import SectionHeading from "../SectionHeading/SectionHeading";

const TerminalAssessmentRankingHeader = ({ data, grades }) => {
  const getTermName = (term) => {
    switch (parseInt(term)) {
      case 1:
        return "1st Terminal Assessment";
      case 2:
        return "2nd Terminal Assessment";
      case 3:
        return "Final Terminal Assessment";
      default:
        return `${term}th Terminal Assessment`;
    }
  };

  return (
    <Container fluid className="py-0">
      <div className="position-relative">
        <SectionHeading
          noLogo={false}
          subtitle={`${getTermName(data?.extra?.term)} -${data?.extra?.year}`}
          grade={data?.extra?.gradeId}
          shift={data?.extra?.shiftId}
          batch={data?.extra?.batchId}
          text={`${getTermName(data?.extra?.term)} -${data?.extra?.year}`}
        />
        <div className="d-flex align-items center justify-content-center pb-2">
          <div className="d-flex justify-content-center flex-wrap">
            <span className="d-block pe-3">
              <span className="fw-bold ">
                <u>Evaluation</u>
              </span>
            </span>
            <span className="d-block pe-3">
              <span className="fw-bold">A++</span> = (90-100)
            </span>
            <span className="d-block pe-3">
              <span className="fw-bold">A+</span> = (80-89)
            </span>
            <span className="d-block pe-3">
              <span className="fw-bold">A</span> = (70-79)
            </span>
            <span className="d-block pe-3">
              <span className="fw-bold">A-</span> = (60-69)
            </span>
            <span className="d-block pe-3">
              <span className="fw-bold">B</span> = (50-59)
            </span>
            <span className="d-block pe-3">
              <span className="fw-bold">C (Fail)</span> = {"(<50)"}{" "}
            </span>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default TerminalAssessmentRankingHeader;
